<template>
    <div>
        <!--Navigation Drawer-->
        <v-navigation-drawer
                fixed
                :clipped="$vuetify.breakpoint.mdAndUp"
                app
                v-model="drawer"
                :enable-resize-watcher="drawer"
                class="navDrawer mainNavDrawer"
                width="300"
        >
            <!-- List of items in Nav Drawer -->
            <v-list dense class="primary--text pb-12">
                <template v-for="(item, i) in filteredItems">
                    <!-- Items with title witch are not expanding -->
                    <v-list-item
                            :key="i"
                            v-if="item.title"
                            router
                            :to="item.link"
                    >
                        <v-list-item-action>
                            <v-icon>{{ item.icon }}</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{ item.title }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <!-- Expanding main group section -->
                    <v-list-group
                        :key="i"
                        v-else-if="item.title_expand"
                        :class="{'subscription-disabled': (!(isSubscribed || isTrialActive) && !['Settings'].includes(item.title_expand))}"
                    >
                        <!-- Main title -->
                        <v-list-item :class="{'subscription-disabled': (!(isSubscribed || isTrialActive) && !['Settings'].includes(item.title_expand))}" slot="activator">
                            <v-list-item-action>
                                <v-icon color="grey darken-1" :class="{'subscription-disabled': (!(isSubscribed || isTrialActive) && !['Settings'].includes(item.title_expand))}">{{item.icon}}</v-icon>
                            </v-list-item-action>
                            <v-list-item-title>{{item.title_expand}}</v-list-item-title>
                        </v-list-item>
                        <!-- subtitlesSectionOne -->
                        <v-list-item
                                v-for="(item, i) in item.subtitlesSectionOne"
                                :key="i"
                                router
                                :to="item[1]"
                                :class="{'subscription-disabled': (!(isSubscribed || isTrialActive) && !['Subscription Details'].includes(item[0]))}"
                        >
                            <v-list-item-action>
                                <v-icon :class="{'subscription-disabled': (!(isSubscribed || isTrialActive) && !['Subscription Details'].includes(item[0]))}">{{item.icon}}</v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title :class="item.length < 2  ?  'menu-link-disabled':''">
                                    {{ item[0] }}
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <!-- Sub Expanding group 1-->
                        <v-list-group
                                sub-group
                                no-action
                                v-if="item.sub_group_one_children"
                                class="subGroupOne"
                        >
                            <!-- Title -->
                            <v-list-item
                                    slot="activator"
                                    class="subGroupTitle"
                            >
                                <v-list-item-title>{{item.sub_group_one_title}}</v-list-item-title>
                            </v-list-item>
                            <!-- Item title -->
                            <v-list-item
                                    v-for="(item, i) in item.sub_group_one_children"
                                    :key="i"
                                    router
                                    :to="item[1]"
                                    class="subGroupChildren"
                            >
                                <v-list-item-title :class="item.length < 2  ?  'menu-link-disabled':''">
                                    {{ item[0] }}
                                </v-list-item-title>
                            </v-list-item>
                        </v-list-group>
                        <!-- subtitlesSectionOne Two -->
                        <v-list-item
                                v-for="(item, i) in item.subtitlesSectionTwo"
                                :key="i"
                                router
                                :to="item[1]"
                        >
                            <v-list-item-action>
                                <v-icon>{{item.icon}}</v-icon>
                            </v-list-item-action>
                            <v-list-item-title :class="item.length < 2  ?  'menu-link-disabled':''">
                                {{ item[0] }}
                            </v-list-item-title>
                        </v-list-item>
                        <!-- Sub Expanding group 2-->
                        <v-list-group
                                sub-group
                                no-action
                                v-if="item.sub_group2_children"
                        >
                            <!-- Title -->
                            <v-list-item
                                    slot="activator"
                                    class="subGroupTitle"
                            >
                                <v-list-item-title>{{item.sub_group2_title}}</v-list-item-title>
                            </v-list-item>
                            <!-- Item title -->
                            <v-list-item
                                    v-for="(item, i) in item.sub_group2_children"
                                    :key="i"
                                    router
                                    :to="item[1]"
                            >
                                <v-list-item-title :class="item.length < 2  ?  'menu-link-disabled':''">
                                    {{ item[0] }}
                                </v-list-item-title>
                            </v-list-item>
                        </v-list-group>
                        <v-list-group
                                sub-group
                                no-action
                                v-if="item.sub_group3_children"
                        >
                            <!-- Title -->
                            <v-list-item
                                    slot="activator"
                                    class="subGroupTitle"
                            >
                                <v-list-item-title>{{item.sub_group3_title}}</v-list-item-title>
                            </v-list-item>
                            <!-- Item title -->
                            <v-list-item
                                    v-for="(item, i) in item.sub_group3_children"
                                    :key="i"
                                    router
                                    :to="item[1]"
                            >
                                <v-list-item-title :class="item.length < 2  ?  'menu-link-disabled':''">
                                    {{ item[0] }}
                                </v-list-item-title>
                            </v-list-item>
                        </v-list-group>
                    </v-list-group>
                </template>
            </v-list>
        </v-navigation-drawer>
        <!-- Toolbar     -->
        <v-app-bar
                id="toolbar"
                dark
                class="header"
                :class="`${getContrast($vuetify.theme.themes.light.header)}--text`"
                app
                :clipped-left="$vuetify.breakpoint.mdAndUp"
                fixed
                extension-height="48px"
        >
            <v-app-bar-nav-icon
                :class="`${getContrast($vuetify.theme.themes.light.header)}--text`"
                @click.stop="drawer = !drawer"
            ></v-app-bar-nav-icon>
            <router-link
                v-if="
                    !no_data.includes(user) &&
                    !no_data.includes(user.franchise_logo)
                "
                to="/"
                style="cursor:pointer"
            >
                <img id="custom-logo-portal" :src="user.franchise_logo" style="vertical-align: text-bottom;" alt="Franchise Logo"/>
            </router-link>
            <router-link v-else to="/" style="cursor:pointer">
                <img id="logo-portal" :src="logo_icon" style="vertical-align: text-bottom;" alt="Sweep and Go Logo" />
                <img id="logo-portal-small" :src="small_logo_icon" style="vertical-align: text-bottom;" alt="Sweep and Go Logo" />
            </router-link>
            <v-spacer></v-spacer>
            <v-toolbar-title :class="`${getContrast($vuetify.theme.themes.light.header)}--text`" style="font-size: 12px; font-weight: normal; padding-left: 5px; padding-right: 5px;">{{ `${managedBy}v${version}` }}</v-toolbar-title>
            <v-toolbar-items
                class="toolbar-items">
                <v-layout class="align-center fill-height">
                <v-btn icon class="ma-1 toolbar-icons" @click="markAsReadNotifications()" :class="`${getContrast($vuetify.theme.themes.light.header)}--text`">
                    <v-badge top color="error" :bordered="getTwoColorContrast($vuetify.theme.themes.light.header, '#ff5252', true) <= 2" :overlap="true" :value="notificationShow">
                        <template v-slot:badge>
                            <span small style="font-size: 12px;">{{new_notifications > 9 ? '9+' : new_notifications}}</span>
                        </template>
                        <v-icon>notifications</v-icon>
                    </v-badge>
                </v-btn>
                <v-tooltip v-if="Array.isArray(users) && users.length > 6" bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon class="ml-n2 toolbar-icons" @click="openSwitchAccountDialog()" :class="`${getContrast($vuetify.theme.themes.light.header)}--text`">
                        <v-icon>swap_horiz</v-icon>
                    </v-btn>
                  </template>
                  <span>Select Another Account</span>
                </v-tooltip>
                <v-menu light offset-y bottom left content-class="fixed-meny">  
                    <template v-slot:activator="{ on }">
                        <v-avatar v-on="on" size="30" :color="getContrast($vuetify.theme.themes.light.header) === 'black' ? 'accent' : 'white'" class="toolbar-icons pointer">
                            <img v-if="!no_data.includes(user.avatar)" :src="user.avatar" alt="User Avatar" />
                            <span v-else class="title" :class="getContrast($vuetify.theme.themes.light.header) === 'black' ? 'white--text' : 'accent--text'">{{ user.full_name.charAt(0)}}</span>
                        </v-avatar>
                    </template>
                    <v-card three-line style="width: 300px;">
                        <template v-if="Array.isArray(users) && users.length > 1 && !(users.length > 6)">
                            <v-list class="py-0">
                                <v-list-group
                                    no-action
                                    @click.stop=""
                                >
                                    <template v-slot:activator>
                                        <v-list-item-avatar color="primary">
                                            <img v-if="!no_data.includes(user.avatar)" :src="user.avatar" alt="User Avatar" />
                                            <span v-else class="title" style="color: #fff;">{{ user.full_name.charAt(0)}}</span>
                                        </v-list-item-avatar>

                                        <v-list-item-content>
                                            <v-list-item-title>{{ user.full_name }}</v-list-item-title>
                                            <v-list-item-subtitle>{{ user.organization_name }}</v-list-item-subtitle>
                                        </v-list-item-content>
                                    </template>
                                    <v-divider></v-divider>                                   
                                    <div class="px-4 mt-3 mb-1 black--text" @click.stop="">Select Another Account</div>
                                    <v-list-item v-for="(item, index) in anotherAccounts" :key="index" class="pl-4 py-0 pointer" @click="switchAccount(item)">
                                        <v-list-item-avatar :key="`${index}avatar`" color="primary">
                                            <img v-if="!no_data.includes(item.avatar)" :src="item.avatar" alt="User Avatar" />
                                            <span v-else class="title" style="color: #fff;">{{ item.full_name.charAt(0)}}</span>
                                        </v-list-item-avatar>

                                        <v-list-item-content :key="`${index}content`">
                                            <v-list-item-title>{{ item.full_name }}</v-list-item-title>
                                            <v-list-item-subtitle>{{ item.organization_name }}</v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list-group>
                            </v-list>
                            <v-divider></v-divider>
                        </template>
                        <template v-else>
                            <v-list class="py-0">
                                <div @click.stop="" class="py-2">
                                <v-list-item id="single-account">
                                    <v-list-item-avatar color="primary">
                                        <img v-if="!no_data.includes(user.avatar)" :src="user.avatar" alt="User Avatar" />
                                        <span v-else class="title" style="color: #fff;">{{ user.full_name.charAt(0)}}</span>
                                    </v-list-item-avatar>

                                    <v-list-item-content>
                                        <v-list-item-title>{{ user.full_name }}</v-list-item-title>
                                        <v-list-item-subtitle>{{ user.organization_name }}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                                </div>
                            </v-list>
                            <v-divider></v-divider>
                        </template>
                        <v-list>
                            <v-list-item
                                @click="vEmit({ name: 'LoginAnotherAccount' })"
                            >
                                <v-list-item-title style="font-size: 13px;">Log in With Another Account</v-list-item-title>
                            </v-list-item>
                            <v-list-item
                                v-if="this.permissions.includes('change_password')"
                                @click="$router.push('/change_password')"
                            >
                                <v-list-item-title style="font-size: 13px;">Change Password</v-list-item-title>
                            </v-list-item>
                            <v-list-item
                                v-if="this.permissions.includes('change_email')"
                                @click="$router.push('/change_email')"
                            >
                                <v-list-item-title style="font-size: 13px;">Change Email</v-list-item-title>
                            </v-list-item>
                            <v-list-item
                                v-if="this.permissions.includes('two_factor')"
                                @click="$router.push('/two_factor')"
                            >
                                <v-list-item-title style="font-size: 13px;">Two-Factor Authentication</v-list-item-title>
                                <v-list-item-action v-if="Number(two_factor_enabled) === 1" style="justify-content: flex-end;"><v-icon color="success">done</v-icon></v-list-item-action>
                            </v-list-item>
                            <v-divider></v-divider>
                            <v-list-item
                                @click="logout"
                                color="primary"
                            >
                                <v-list-item-title class="text-uppercase" style="font-size: 14px;">Logout</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-card>
                </v-menu>

                </v-layout>
            </v-toolbar-items>
            <v-layout v-if="!isSubscribed && this.permissions.includes('subscription_details')" slot="extension" style="background: #f4f4f4; color: black;">
                <SubscribeNow></SubscribeNow>
            </v-layout>
        </v-app-bar>
        <v-main>
            <notification-message></notification-message>
            <v-container id="main-content" class="container--fluid fill-height py-3 py-sm-6 px-0 px-sm-1 px-md-6">
                <v-layout class="justify-center align-center">
                    <main role="main" class="container container--fluid pa-3 pa-sm-6">
                        <router-view :key="$route.path"></router-view>
                    </main>
                </v-layout>
                <light-box></light-box>
                <plan-status></plan-status>
                <login-another-account></login-another-account>
            </v-container>
        </v-main>
        <v-dialog v-if="switchAccountDialog" v-model="switchAccountDialog" max-width="500px" persistent>
            <v-card class="pa-4">
                <v-card-title class="px-4">
                    <h2 class="title">Select Another Account</h2>
                </v-card-title>
                <v-form @submit.prevent="" class="px-5 pt-5">
                    <v-autocomplete
                        :items="anotherAccounts"
                        v-model="selectedAccount"
                        label="Account"
                        placeholder="Please Select"
                        class="my-3"
                        return-object
                        :item-text="i => `${i.full_name} - ${i.organization_name}`"
                        item-value="id"
                    >
                    </v-autocomplete>
                    <v-card-actions class="px-0">
                        <v-spacer></v-spacer>
                        <v-btn color="primary" text @click="switchAccountDialog = false">Cancel</v-btn>
                        <v-btn
                            color="primary"
                            :disabled="no_data.includes(selectedAccount)"
                            @click="selectAndSwitchToAnotherAccount">
                            Select
                        </v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
    </div>
</template>


<script>
    import NotificationMessage from './NotificationMessage'
    import LightBox from './LightBox'
    import PlanStatus from './PlanStatus'
    import LoginAnotherAccount from './LoginAnotherAccount'
    import {LOGOUT} from "@/store/actions.type"
    import { UPDATE_STRIPE_STATUS } from "@/store/mutations.type"
    import ApiService from "@/common/api.service"
    import {PUSHER_KEY} from "@/common/config"
    import Pusher from 'pusher-js'
    import {getOrganizationId} from "@/common/jwt.service"
    import SubscribeNow from "./SubscribeNow"
    import { mapGetters, mapState, mapMutations, mapActions } from "vuex"

    export default {
        name: 'UserLayout',
        data: () => ({
            no_data: [null, '', undefined, 'null'],
            dialog: false,
            logo_icon: require('@/assets/img/logo/logo.png'),
            small_logo_icon: require('@/assets/img/logo/footer-logo.png'),
            drawer: '',
            loading: true,
            new_messages: 0,
            new_notifications: 0,
            notificationShow: false,
            messageShow: false,
            loadingNewUser: false,
            items: [
                {icon: 'home', title: 'Home', link: '/'},
                {
                    icon: 'business_center', title_expand: 'Clients',
                    subtitlesSectionOne: [
                        ['Residential Clients', '/clients', 'clients'],
                        ['Commercial Clients', '/commercial_clients', 'commercial_clients'],
                        ['Change Requests', '/change_requests', 'change_requests']
                    ]
                },
                {
                    icon: 'person', title_expand: 'Staff',
                    subtitlesSectionOne: [
                        ['Staff List', '/staff', 'staff'],
                        ['Shifts', '/shifts', 'shifts'],
                        ['My Shift Report', '/my_shift_report', 'my_shift_report'],
                        ['Time & Mileage Report', '/time_mileage_report', 'time_mileage_report'],
                        ['Start/End My Shift', '/start_end_shift', 'start_end_shift'],
                    ]
                },
                {
                    icon: 'today', title_expand: 'Scheduler',
                    subtitlesSectionOne: [
                        ['Dispatch Board', '/dispatch_board', 'dispatch_board'],
                        ['Route Manager', '/route_manager', 'route_manager'],
                        ['Schedule', '/schedule', 'schedule'],
                        ['Unassigned', '/unassigned', 'unassigned'],
                    ]
                },
                {
                    icon: 'receipt', title_expand: 'Billing',
                    subtitlesSectionOne: [
                        ['Residential Subscriptions', '/subscriptions', 'subscriptions'],
                        ['Commercial Subscriptions', '/commercial_subscriptions', 'commercial_subscriptions'],
                        ['Recurring Invoices', '/recurring_invoices', 'recurring_invoices'],
                        ['One Time Invoices', '/one_time_invoices', 'one_time_invoices'],
                        ['Payments', '/payments', 'payments'],
                        ['Coupons', '/coupons', 'coupons'],
                        ['Gift Certificates', '/gift_certificates', 'gift_certificates'],
                        ['Payouts', '/payouts', 'payouts'],
                        ['Sales Tax Report', '/sales_tax_report', 'sales_tax_reports'],
                    ],
                },
                {
                    icon: 'local_atm', title_expand: 'Payroll',
                    subtitlesSectionOne: [
                        ['Create Pay Slips', '/create_pay_slips', 'create_pay_slips'],
                        ['Payroll Report', '/payroll_report', 'payroll_report'],
                        ['Productivity Report', '/productivity_report', 'productivity_report']
                    ],
                },
                {
                    icon: 'insert_chart', title_expand: 'Reports',
                    subtitlesSectionOne: [
                        ['Route Planning', '/route_planning_report', 'route_planning_report'],
                        ['Completed Jobs', '/completed_jobs_report', 'completed_jobs_report'],
                        ['Residential Cross-Sells', '/residential_cross_sells_report', 'additional_residential_services_report'],
                        ['Commercial Cross-Sells', '/commercial_cross_sells_report', 'additional_commercial_services_report'],
                        ['Open Balance Report', '/open_balance_report', 'open_balance_report'],
                        ['Cleanup Notifications Report', '/cleanup_notifications_report', 'cleanup_notifications_report'],
                        ['Ratings & Comments', '/ratings_and_comments_report', 'ratings_and_comments_report'],
                        ['Tips', '/tips_report', 'tips_report'],
                        ['Work Area Activity Log', '/work_area_activity_log', 'work_area_activity_log'],
                        ['Work Area Inventory', '/work_area_inventory', 'work_area_inventory'],
                    ],
                },
                { 
                    icon: 'settings',
                    title: 'Settings',
                    link: '/settings',
                    nestedPermissions: [
                        'client_onboarding',
                        'billing_settings',
                        'pricing_setup',
                        'scheduler_settings',
                        'additional_services',
                        'additional_commercial_services',
                        'quickbooks_online',
                        'payroll_settings',
                        'field_tech_app_settings',
                        'client_portal_settings',
                        'branding_settings',
                        'customize_dashboard',
                        'open_api',
                        'royalty_payments',
                        'subscription_details'
                    ]
                },
            ],
            filteredItems: [],
            switchAccountDialog: false,
            selectedAccount: null,
        }),
        components: {
            NotificationMessage,
            LightBox,
            SubscribeNow,
            PlanStatus,
            LoginAnotherAccount
        },
        props: {
            source: String
        },
        beforeMount() {
            this.navDrawerMobile();
            this.filterItems();
        },
        mounted() {
        },
        created() {
            this.subscribeNotifications()
            this.pullUnreadNotifications()
            this.subscribeStripeStatus()
        },
        methods: {
            ...mapMutations(["setUser", "setUsers"]),
            ...mapActions(["checkOrganizationSettings", "checkAuthSwitchAuth", 'vEmit']),
            subscribeNotifications() {
                let pusher = new Pusher(PUSHER_KEY, {
                    cluster: 'us2',
                    forceTLS: true
                });
                let organization_id = getOrganizationId();
                let channel = pusher.subscribe('notifications.'+organization_id+'.0');
                channel.bind('NotificationClientRegistrationPosted', data => {
                    this.new_notifications += 1;
                    this.notificationShow = true;
                });
            },
            subscribeStripeStatus() {
                let pusher = new Pusher(PUSHER_KEY, {
                    cluster: 'us2',
                    forceTLS: true
                });
                let organization_id = getOrganizationId();
                let channel = pusher.subscribe('stripe_status.'+organization_id);
                channel.bind('OrganizationStripeStatusUpdated', data => {
                    this.$store.commit(UPDATE_STRIPE_STATUS, data)
                });
            },
            openSwitchAccountDialog () {
                this.selectedAccount = this.anotherAccounts[0]
                this.switchAccountDialog = true
            },
            selectAndSwitchToAnotherAccount () {
                this.switchAccount(this.selectedAccount)
                this.switchAccountDialog = false
            },
            switchAccount(data) {
                let user = _.cloneDeep(data)
                let token = data.token
                delete user.token
                // update current user in users array
                if(this.users.some(i => i.user_id === this.user.user_id && i.organization_id === this.user.organization_id)) {
                    let currentUser = _.cloneDeep(this.user)
                    let indexInUsers = this.users.findIndex(i => i.user_id === this.user.user_id && i.organization_id === this.user.organization_id)
                    let currentToken = String(this.users[indexInUsers].token)
                    currentUser.token = currentToken
                    let newUsers = _.cloneDeep(this.users)
                    newUsers[indexInUsers] = currentUser
                    this.setUsers(newUsers)
                }
                // set new user
                this.loadingNewUser = true
                this.checkAuthSwitchAuth({ user, token })
                    .then(response => {
                        this.loadingNewUser = false
                        this.checkOrganizationSettings(true)
                        if (this.firstLogin) {
                            if (this.$route.name !== "change_password") {
                                this.$router.push({name: "change_password"})
                            } else {
                                this.$router.go(0)
                            }
                        } else {
                            if (this.$route.name !== "dashboard") {
                                this.$router.push({name: "dashboard"})
                            } else {
                                this.$router.go(0)
                            }
                        }
                    })
                    .catch(response => {
                        this.loadingNewUser = false
                        let errorMessage = 'Oops something went wrong...'
                        if (response.data && response.data.error) {
                            errorMessage = this.titleCase(response.data.error)
                        }
                        if (response.data && response.data.message) {
                            errorMessage = response.data.message
                        }
                        if (response.data && response.data.errors && response.data.errors.length) {
                            errorMessage = response.data.errors[0]
                        }
                        this.vEmit({ 
                            name: "notification", 
                            data: {
                                status: 'error', 
                                text: errorMessage
                            }
                        })
                    })
            },
            logout() {
                this.$store
                    .dispatch(LOGOUT)
                    .then(() => this.$router.push({name: "login"}));
            },
            navDrawerMobile() {
                if (window.innerWidth < 1264) {
                    this.drawer = false;
                } else {
                    this.drawer = true;
                }
            },
            pullUnreadNotifications() {
                ApiService.get('notification/count_unread_notifications').then(response => {
                    let unreadMessages = response.data.messages;
                    if(unreadMessages){
                        this.notificationShow = true;
                        this.new_notifications+=unreadMessages;
                    }
                });
            },
            markAsReadNotifications(){
                this.notificationShow = false;
                this.new_notifications=0;
                this.$router.push({name: "notifications"});
            },
            filterItems () {
                let items = _.cloneDeep(this.items)
                items.forEach(i => {
                    if (i.title_expand) {
                        if (!Boolean(this.user.belongs_to_franchise)) {
                            i.subtitlesSectionOne = i.subtitlesSectionOne.filter(s => s[0] !== 'Royalty Payments')
                        }
                        i.subtitlesSectionOne = [...i.subtitlesSectionOne.filter(s => { return this.permissions.includes(s[2])})]
                    }
                })
                items = items.filter(i => {
                    if(i.title) {
                        return this.permissions.includes(i.link) ||
                            i.link === '/' ||
                            (
                                i.link === '/settings' &&
                                i.nestedPermissions.some(p => this.permissions.includes(p))
                            )
                    } else if (i.title_expand) {
                        return i.subtitlesSectionOne.length > 0
                    }
                })
                this.filteredItems = _.cloneDeep(items)
            },
            titleCase(str) {
                return _.startCase(str.replace(/_/g, " "));
            }
        },
        computed: {
            ...mapGetters(["user", "users", "firstLogin", "isSubscribed", "isTrialActive", "subscriptionPackage", "stripeCompleted", "permissions", "getContrast", "getTwoColorContrast"]),
            ...mapState({
                two_factor_enabled: state => state.auth.user.two_factor,
                version: state => state.auth.version
            }),
            anotherAccounts () {
                if (
                    !this.no_data.includes(this.users) &&
                    Array.isArray(this.users) &&
                    this.users.length > 1
                ) {
                    return this.users.filter(i => i.user_id !== this.user.user_id || i.organization_id !== this.user.organization_id)
                } else {
                    return []
                }
            },
            managedBy () {
                let out = ''
                if (
                    !this.no_data.includes(this.user) &&
                    !this.no_data.includes(this.user.belongs_to_franchise) &&
                    !this.no_data.includes(this.user.belongs_to_franchise_name)
                ) {
                    out = `Managed by ${this.user.belongs_to_franchise_name} | `
                }
                return out
            }
        },
        watch: {
            permissions: {
                handler(val) {
                    this.filterItems()
                },
                deep: true
            }
        }
    }
</script>

<style>
    /*Logo*/
    #logo-portal{
        max-width: 115px;
        margin-left: 10px;
    }

    #logo-portal-small {
        display: none;
        margin-right: 10px;
        max-width: 24px; 
        padding-bottom: 2px;
    }

    /*Toolbar buttons*/
    .toolbar__items {
        height: auto !important;
    }

    /* Old Vuetify version  */
    .navigation-drawer > .list:not(.list--dense) .list__tile {
        font-size: 13px;
        text-decoration: none;
    }

    .navDrawer > .v-list:not(.v-list--dense) .v-list__tile {
        font-size: 13px;
        text-decoration: none;
    }

    /* Old Vuetify version  */
    /* .list__tile--link {
        color: black;
    }

    .v-list__tile--link {
        color: black;
    } */

    /* Old Vuetify version  */
    .navDrawer .subGroupOne .list__group__header--sub-group {
        padding-left: 25px;
    }

    .navDrawer .subGroupOne .v-list__group__header--sub-group {
        padding-left: 25px;
    }

    /* Old Vuetify version  */
    .navDrawer .list__group__items--no-action .list__tile {
        padding-left: 110px;
    }

    .navDrawer .v-list__group__items--no-action .v-list__tile {
        padding-left: 110px;
    }

    .application .theme--light.list, .theme--light .list {
        color: grey;
    }

    /**Navigation Bar Style **/

    .list--dense {
        padding-top: 17px;
    }

    .subheader {
        padding-left: 0px;
    }

    .list__tile__title.sub-text-deactive {
        padding-left: 50px;
        color: grey;
    }

    .list__tile__title.heading-active {
        padding-left: 0px;
    }

    /*If menu item view does not exists*/
    .menu-link-disabled {
        color: grey;
    }

    /*Align buttons hover*/
    toolbar__side-icon.btn.btn--icon {
        margin: -6px;
    }

    .toolbar-icons .btn__content {
        margin: 0px !important;
    }

    /*Progress bar*/
    .progress-linear {
        position: absolute;
        margin-top: 35px;
    }

    @media only screen and (max-width: 600px) {
        .xs-no-padding {
            padding: 0px 0px 32px;
        }
    }

    .v-toolbar__extension {
        background: #f5f5f5;
    }

    .subscription-disabled {
        color: #cdcdcd!important;
    }

    .theme--light.subscription-disabled.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
        color: #cdcdcd!important;
    }

    .theme--light.subscription-disabled.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) i.v-icon {
        color: #cdcdcd!important;
    }

    .v-list .v-list-group--active.subscription-disabled .v-icon {
        color: rgba(0, 0, 0, 0.54);
    }

    .fixed-meny {
        position: fixed!important;
        top: 48px!important;
    }

    @media only screen and (min-width: 960px) {
        .fixed-meny {
            top: 64px!important;
        }
    }

    @media only screen and (max-width: 599px) {
        .v-toolbar .v-toolbar__content, .v-toolbar .v-toolbar__extension {
            padding-left: 12px;
            padding-right: 12px;
        }

        #logo-portal {
            display: none;
        }

        #logo-portal-small {
            display: inline;
        }
    }


</style>

<style>
  .mainNavDrawer .v-list-group .v-list-group__header {
    padding-left: 0;
  }
</style>
